"use client"

import { motion } from "framer-motion"

export function HeroSection() {
    return (
        <section className="relative min-h-dvh overflow-hidden" aria-label="Hero">
            <video
                className="absolute inset-0 h-full w-full object-cover"
                src="/bg.mp4"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                aria-hidden="true"
            />

            <div
                className="absolute inset-0 bg-linear-to-b from-[rgba(0,13,20,0.40)] via-[rgba(0,13,20,0.70)] to-[rgba(0,13,20,0.94)]"
                aria-hidden="true"
            />
            <div className="absolute inset-0 bam-grid opacity-30" aria-hidden="true" />

            <div className="relative bam-container flex min-h-dvh items-center px-6 pt-28">
                <div className="max-w-4xl">
                    <motion.h1
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.65, delay: 0.08 }}
                        className="mt-6 text-balance text-4xl font-semibold tracking-tight text-on-dark sm:text-5xl md:text-6xl"
                    >
                        Empowering Your Digital Transformation.
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.65, delay: 0.16 }}
                        className="mt-6 max-w-3xl text-pretty text-base leading-relaxed text-muted-on-dark sm:text-lg"
                    >
                        Founded in 2023, Barnickel Asset Management is a visionary firm dedicated to empowering
                        digitalization ventures. We specialize in driving growth and innovation through strategic
                        investments and consulting, paving the way for a digital future.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.02 }}
                        className="space-y-2 pt-6"
                    >
                        <div className="text-xs font-semibold tracking-[0.28em] text-on-dark/80">
                            BARNICKEL ASSET MANAGEMENT
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    )
}